module.exports = "/images/side-settings-active.svg?a78e8ce390ff8ab3ab892603f9610a21";